import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/history", label: "History" },
  { to: "/board", label: "Township Board" },
  { to: "/postings", label: "Public Notices" },
  { to: "/minutes", label: "Meeting Minutes" },
  { to: "/calendar", label: "Calendar" },
  { to: "/projects", label: "Projects" },
  { to: "/information", label: "Information" },
  { to: "/links", label: "Links" },
  { to: "/contact", label: "Contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-md border-b border-border" data-testid="site-header">
      <div className="container-le flex items-center justify-between py-4">
        <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link" aria-label="Lake Eunice Township — Home">
          <div className="w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-heading text-lg" aria-hidden="true">
            LE
          </div>
          <div className="leading-tight">
            <div className="font-heading text-lg sm:text-xl font-semibold tracking-tight">Lake Eunice Township</div>
            <div className="text-xs text-muted-foreground tracking-[0.18em] uppercase">Becker County · Minnesota</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" data-testid="primary-nav" aria-label="Primary">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  isActive
                    ? "text-primary bg-muted"
                    : "text-foreground/80 hover:text-primary hover:bg-muted"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <button
          className="lg:hidden p-2 rounded-md hover:bg-muted"
          onClick={() => setOpen((s) => !s)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="mobile-nav"
          data-testid="menu-toggle-btn"
        >
          {open ? <X size={22} aria-hidden="true" /> : <Menu size={22} aria-hidden="true" />}
        </button>
      </div>

      {open && (
        <nav id="mobile-nav" className="lg:hidden border-t border-border bg-white" data-testid="mobile-nav" aria-label="Mobile primary">
          <div className="container-le py-3 grid grid-cols-2 gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-2.5 text-sm font-medium rounded-md ${
                    isActive ? "text-primary bg-muted" : "text-foreground/80 hover:bg-muted"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;
